export const MONITOR_SERVICE_FILTER_QUERY_PARAM = 'ticketIdFilter';
